export const validarSenhaForte = (senha: string) => {
  // Pelo menos 8 caracteres, uma maiúscula, uma minúscula, um número e um caractere especial
  const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).{8,}$/;
  return regex.test(senha);
};
